import { LiveUpdateEventType } from '@services/stomp/live-update';

//ФИАТ
export const onBalanceChangedReceived = (balance) => ({
  type: LiveUpdateEventType.balanceChanged,
  balance: balance,
});
